.header {
  margin-bottom: var(--space-2xl);
}

.icon {
  font-size: var(--text-2xl);
  margin-right: var(--space-sm);
}

.title {
  font-family: var(--font-heading);
  font-size: var(--text-2xl);
  color: var(--accent-cyan);
  letter-spacing: 3px;
  margin-bottom: var(--space-sm);
}

.subtitle {
  font-size: var(--text-sm);
  color: var(--text-muted);
  margin-bottom: var(--space-md);
}

.line {
  height: 1px;
  background: linear-gradient(90deg, var(--accent-cyan), transparent);
  width: 200px;
}
